import { render, staticRenderFns } from "./galleryBlock.vue?vue&type=template&id=10e64976&scoped=true"
import script from "./galleryBlock.vue?vue&type=script&lang=js"
export * from "./galleryBlock.vue?vue&type=script&lang=js"
import style0 from "./galleryBlock.vue?vue&type=style&index=0&id=10e64976&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e64976",
  null
  
)

export default component.exports